<p-overlayPanel [dismissable]="true" #menu [appendTo]="'body'">
  <ng-content select="[panel-body]"></ng-content>
</p-overlayPanel>
